// imports
import React, { FC } from 'react';
import CelebrationIcon from '@mui/icons-material/Celebration';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
// interface
import { ContactMessageDialogProps } from '../../app/interfaceTypes';
import { BUTTON_TEXT_OK, LABEL_CONGRATULATIONS, MSG_FIRST_CONTACT_SUCCESS } from '../../../../shared/lib/constants';
import { withTrademark } from '../../../../shared/lib/common/Tokenizer';

const AddContactMessageDialog: FC<ContactMessageDialogProps> = ({ open, onClose, phoneNo }) => {
  return (
    <Dialog
      open={open}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 4
        }
      }}
    >
      <DialogTitle display="flex" justifyContent="center">
        <CelebrationIcon color="success" sx={{ fontSize: '100px' }} />
      </DialogTitle>
      <DialogContent>
        <Typography fontWeight={700}>{LABEL_CONGRATULATIONS}</Typography>
        <Typography textAlign="justify">
          {withTrademark(MSG_FIRST_CONTACT_SUCCESS(phoneNo || ''))}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button variant="contained" size="large" color="primary" sx={{ minWidth: '50%', color: 'white' }} onClick={onClose}>
          {BUTTON_TEXT_OK}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddContactMessageDialog;
